import 'bootstrap-datepicker'
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.standalone.min.css'

export const form = {
  // 下拉
  formSelect() {
    $('.form-select .dropdown-scrollbar[data-scrollbar-content]').scrollbar();
    $('.dropdown-scrollbar[data-scrollbar-content]').siblings('.scroll-element').on('click', function (e) {
      e.stopPropagation()
    })
    let toggleList = vm => {
      let $select = $(vm);
      if (!$select.hasClass('active')) {
        $select.addClass('active').find('.dropdown').slideDown(500);
        let all = $select.parents('[data-form]').find('.form-select');
        all.not(vm).removeClass('active').find('.dropdown').slideUp(500);
      } else {
        $select.removeClass('active').find('.dropdown').slideUp(500);
      }
    }
    $('.form-select .dropdown li').on('click', function() {
      let $this = $(this);
      let word = $this.text();
      let selected = $this.parents('.dropdown').siblings('.selected')
      selected.addClass('is-select').text(word);
    });
    $('.form-select').on('click', function(e) {
      e.stopPropagation();
      e.preventDefault();
      toggleList(this);
    });
    $(document).on('click', function (e) {
      let $select = $('.form-select');
      $select.removeClass('active').find('.dropdown').slideUp(500);
    });
  },
  // 日曆
  datepicker() {
    $('.datepicker-input').datepicker({
      container: '.form-date',
      autoclose: true,
      orientation: 'left bottom',
      format: 'yyyy/mm/dd'
    });
  },
  // 更換檔名
  updateFiles() {
    $('.wdd-form .file-wrap input[type="file"]').on('change',function(){
      let vm = $(this);
      const val = vm.val();
      const strFile = val.replace(/^.+?\\([^\\]+?)(\.[^\.\\]*?)?$/gi,"$1");
      const fileExt = val.replace(/.+\./,""); 
      const str = `${strFile}.${fileExt}`;
      let defaultText = vm.siblings('.fake-file-upload').attr('data-default')
      let $fileName = vm.siblings('.fake-file-upload').find('.file-name')
      if (strFile != '') {
        $fileName.addClass('is-upload').text(str);
      }
      else {
        $fileName.removeClass('is-upload').text(defaultText);
      }
    });
  },
  // 清除全部選項
  clear() {
    $('.wdd-form input').val('');
    $('.wdd-form textarea').val('');
    $('.wdd-form input[type="checkbox"]').prop('checked', false);
    $('.fake-file-upload').each(function (index, el) {
      let defaultText = $(el).attr('data-default')
      $(el).find('.file-name').removeClass('is-upload').text(defaultText)
    });
    $('.form-select').each(function (index, el) {
      let defaultText = $(el).attr('data-default')
      $(el).find('.selected').removeClass('is-select').text(defaultText)
    });
    $(`.select-check .selected`).show();
    $(`.select-label`).remove();
    $(`.select-item`).removeClass('active');
    $('.wdd-form .tips').hide();
  },
  // 展開項目
  spread() {
    let el = $('.fold');

    if(el.length >= 0) true
    else return 

    $('.fold p').on('click',function(){
      if(!$(this).hasClass('active')){
        $(this).addClass('active');
        $(this).siblings('.fold-item').slideDown(400);
      }else{
        $(this).removeClass('active');
        $(this).siblings('.fold-item').slideUp(400);
      }
    });
  },
  // 篩選+下拉
  selectCheck() {
    const dom = (text, id) => {
      return `
        <div class="select-label" data-id=${id}>
          <div class="icon-wrap">
            <div class="icon-x">
            </div>
          </div>
          <div class="t">${text}</div>
        </div>
      `
    };

    const oldTCheck = (target) => {
      let nowLabel= $(target).parents('.form-grid').find('.select-label');
      let oldT = $(target).parents('.form-grid').find('.selected');
      let oldT2 = $(target).parents('.form-grid').find('.tips');
      if(nowLabel.length) {
        oldT.hide();
        oldT2.hide();
      } else {
        oldT.show();
      }
    };

    $('.select-check-wrap').on('click', function() {
      let selectItems = $(this).parents('.form-grid').find('.select-check-box');
      let tips = $(this).parents('.form-grid').find('.tips');
      $(this).toggleClass('active');
      selectItems.slideToggle(400);
      tips.hide();
    });

    $('.select-item').on('click', function() {
      let text = $(this).find('.val').text();
      let target = $(this).parents('.form-grid').find('.select-label-box');
      let nowID = $(this).attr('data-id');

      if($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(`.select-label[data-id='${nowID}']`).remove();
      } else {
        $(this).addClass('active');
        target.append(dom(text, nowID));
      }

      oldTCheck($(this));
    });

    $('.select-label-box').on('click', '.select-label', (e) => {
      e.stopPropagation();
    });

    $('.select-label-box').on('click', '.select-label .icon-wrap', function() {
      let nowParent = $(this).parents('.select-label-box');
      let nowID = $(this).parents('.select-label').attr('data-id');
      $(`.select-label[data-id='${nowID}']`).remove();
      $(`.select-item[data-id='${nowID}']`).removeClass('active');
      oldTCheck(nowParent);
    });
  },
  //
  all() {
    form.formSelect()
    form.datepicker()
    form.updateFiles()
    form.spread()
    form.selectCheck()
    $('.form-group .textarea-scrollbar').scrollbar()
    $('.form-clear').on('click', function () {
      form.clear()
    });
  }
}

// 給後端
_common.formFunc = form;